import isObject from 'lodash/isObject';
import map from 'lodash/map';
import mapValues from 'lodash/mapValues';
import { IParseOptions, IStringifyOptions, parse, stringify } from 'qs';

export function convertStringObjectToObject<A>(obj: A): A {
  // Адресная строка дает только строки, есть ошибки, нужны числа
  // @ts-ignore
  const mapRecursive = (param: any) => {
    if (!isObject(param)) {
      if (param === null || param === 'null') {
        return null;
      }
      if (param === 'false') {
        return false;
      }
      if (param === 'true') {
        return true;
      }
      if (!Number.isNaN(Number(param))) {
        // Параметр может быть строкой с нулями вначеле, например "002" (кроме одиночного нуля "0")
        if (param.startsWith('0') && param.length > 1) {
          return param;
        }

        // Если значение больше максимального, то это проблема клиента. Пока не поддерживаем BigInt
        if (Number.MAX_SAFE_INTEGER < Number(param)) {
          return param;
        }

        return Number(param);
      }

      return param;
    }

    if (Array.isArray(param)) {
      return map(param, (item) => mapRecursive(item));
    }

    return mapValues(param, (item) => mapRecursive(item));
  };

  return mapRecursive(obj);
}

export interface IObjectToSearchParamsOptions extends IStringifyOptions {
  noEmptyStrings?: boolean;
}

interface IAccProps {
  [key: string]: any;
}

export function objectToSearchParams(values?: any, options: IObjectToSearchParamsOptions = {}): string {
  const { noEmptyStrings, ...rest } = options;
  let prepareObj = values || {};

  if (noEmptyStrings) {
    prepareObj = Object.keys(prepareObj).reduce((acc: IAccProps, key: string) => {
      if (!(prepareObj[key] === '' || !prepareObj[key])) {
        acc[key] = prepareObj[key];
      }

      return acc;
    }, {});
  }

  return stringify(prepareObj, { strictNullHandling: true, encode: false, ...rest });
}

export interface ISearchParamsToObjectOptions extends IParseOptions {
  convertStrings?: boolean;
}

export function searchParamsToObject(str?: string, options: ISearchParamsToObjectOptions = {}) {
  const { convertStrings, ...rest } = options;
  if (!str) {
    return {};
  }
  const convertedString = parse(str, { strictNullHandling: true, ...rest });
  return convertStrings ? convertStringObjectToObject(convertedString) : convertedString;
}
